import { ContentTitle } from "../../layout/ContentLayout";

const Usage = ({ organizationId }) => {
  return (
    <>
      <ContentTitle>Usage</ContentTitle>
    </>
  );
};

export default Usage;
